export default __webpack_public_path__ + "static/media/customize_icon.4e9a73af.svg";